import script from "./UploadFile.vue?vue&type=script&lang=ts&setup=true"
export * from "./UploadFile.vue?vue&type=script&lang=ts&setup=true"

import "./UploadFile.vue?vue&type=style&index=0&id=2e8d133a&lang=scss&scoped=true"

import exportComponent from "/root/workspace/Client_OdpJ/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e8d133a"]])

export default __exports__